// import { t } from "element-plus/lib/locale";
import flowapis  from "../../api/yj";
import LoanDetail from "../YjDetail/index.vue";
import LoanAudit from "../YjAudit/index.vue"
import LoanBankAudit from "../YjBankAudit/index.vue"
import fddapis from "../../api/fdd";
import QRCode from 'qrcodejs2';

export default {
    name: "Flow",
    components: {
      LoanDetail,
      LoanAudit,
      LoanBankAudit
    },
    data() {
        return {
            allshow:false,
            detailVisible:false,
            ewmVisible:false,
            dataDetail:{},
            query: {
                keyword: "",
                type:"1",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "Id",
                    "label": "流程编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "UserName",
                    "label": "申请人",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "CompanyName",
                  "label": "用户公司",
                  "width": "",
                  "align": "center"
              },
                {
                  "prop": "BankName",
                  "label": "银行",
                  "width": "",
                  "align": "center"
              },
                {
                    "prop": "Money",
                    "label": "金额/万元",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "State",
                  "label": "当前节点",
                  "width": "140",
                  "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "最后更新时间",
                    "width": "160",
                    "align": "center"
                },
                // {
                //   "prop": "Type",
                //   "label": "类型",
                //   "width": "160",
                //   "align": "center"
                // },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            nowdata:{},
            nowuser:"银行",
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            type:1,//1银行分配2银行转交3担保分配4担保转交
            userList:[],
        };
    },
    created() {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        var list = meta.permBtns
        for(var i=0;i<list.length;i++){
          var name=list[i].ButtonName;
          if(name=="应急_查看全部")this.allshow=true;
        }
      }
    },
    activated(){
      this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
          handleDelete(Id) {
            let that = this;
            if(Id){
                this.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = {
                        Id:Id,IsDelete:1
                    }
                    flowapis.deleteYjFlow(obj).then(res => {
                        //0成功
                        //-1失败
                        //-2用户不存在
                        if(res){
                            this.$message.success("删除成功");
                            that.getData();
                        }else{
                            this.$message.error("删除失败，请重试。");
                        }
                    });
                }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        getData(){
          let param=this.query;
          flowapis.getYjFlowList(param).then(res => {
            this.tableData=res.list;
            if(this.tableData&&this.tableData.length>0){
              for(let i=0;i<this.tableData.length;i++){
                if(this.tableData[i].FinalMoney&&this.tableData[i].FinalMoney!==0){
                  this.tableData[i].FinalMoney2 = this.tableData[i].FinalMoney*1.0/1000000
                }
              }
            }
            this.$data.pageTotal=res.count
          });
        },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        handleEmpty(){
           this.query={
            keyword: "",
            type:"1",
            pageIndex: 1,
            pageSize: 10
        }
        },
        handleView(row) {
          // this.detailVisible=true;
          // this.dataDetail=row;
          let that = this
          that.$refs.loanDetail.onChangeOpen()
          that.$refs.loanDetail.queryData(row)
        },
                // 担保经理审核
         handleAudit(row,flag) {
          let that = this
          that.$refs.loanAudit.onChangeOpen()
          that.$refs.loanAudit.queryData(row,flag)
        },
        handleEWM(row){
           this.nowdata=row;
           this.ewmVisible=true;
           this.changeEWM()
        },
        changeEWM(){
          var url="";
          var nowuser=this.nowuser;
          var row=this.nowdata;
           if(nowuser=="银行"&&row.BankEWM)url=row.BankEWM;
           else if(nowuser=="申请用户"&&row.UserEWM)url=row.UserEWM;
           else if(nowuser=="用户配偶"&&row.POUserEWM)url=row.POUserEWM;
            if(url){
                  this.getEWM(url);
            } 
           else {
         let that = this
            let param={Id:row.FddSignId,actor:nowuser,flowId:row.Id}
            flowapis.getYjAuditParam(param).then(res => {
              if(res){
                 if(nowuser=="银行")row.BankEWM=res
                 else if(nowuser=="申请用户")row.UserEWM=res
                 else if(nowuser=="用户配偶")row.POUserEWM=res
                 that.getEWM(res);
              }else {
                that.$message.error("获取链接失败");
              }
           })
           }
        },
        getEWM(url){
                 var that=this;
                 that.$nextTick(() => {
                   that.$refs.qrCodeUrl.innerHTML = ''
                   let qrcode = new QRCode(that.$refs.qrCodeUrl, {
                       text: url, // 需要转换为二维码的内容
                       width: 200,
                       height: 200,
                       colorDark: '#000000',
                       colorLight: '#ffffff',
                       correctLevel: QRCode.CorrectLevel.H
                   })  
               });
        },
         toViewSign(){
                    var url="";
          var nowuser=this.nowuser;
          var row=this.nowdata;
           if(nowuser=="银行"&&row.BankEWM)url=row.BankEWM;
           else if(nowuser=="申请用户"&&row.UserEWM)url=row.UserEWM;
           else if(nowuser=="用户配偶"&&row.POUserEWM)url=row.POUserEWM;
           if(url){
                              navigator.clipboard.writeText(url);
                              this.$message.success("复制成功");
           }            
        },
        handleBankAudit(row,flag) {
          let that = this
          that.$refs.loanBankAudit.onChangeOpen()
          that.$refs.loanBankAudit.queryData(row)
        },
        // 银行审核完回调函数，用于重新查询列表
        bankAuditSucess(){
          this.getData();
        },
      //获取经理列表
      getUserList(){
        var type=this.type;
        let param={
          type:type,
          bankName:this.dataDetail.BankName,
          bankSiteName:this.dataDetail.BankSiteName
        }
        flowapis.getUserListForAudit(param).then(res => {
          this.userList=res;
      });
      },
      //获取经理选中情况
      getUserState(row){
        var UserID="";   
        var type=this.type;
        if(type==3||type==4)UserID=this.dataDetail.SixUser;
        else UserID=this.dataDetail.ThirdUser;
        if(row.UserID==UserID)return true;
        else return false;
        
      },


        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112
            this.scrollHeight = height;
          });
        },
    },

  };
